<template>
  <div class="intr">
    <v-container>
      <div class="icon-wrap">
        <div class="m-collection-wrap">
          <div class="img">
            <a
              target="_blank"
              :href="`#/commonDetail?id=${curDetail.video}`"
              :title="curDetail.title"
              rel="opener"
            >
              <img :src="curDetail.img" :alt="curDetail.title" />
            </a>
          </div>
          <div class="content">
            <p class="name">
              <span>
                <a :href="`#/commonDetail?id=${curDetail.video}`" target="_blank" rel="opener">
                  {{ curDetail.title }}
                </a>
              </span>
            </p>
            <div class="introduce-items">
              <p class="introduce-item">
                导演：<a href="javascript:;">
                  {{ curDetail.director || "未知" }}
                </a>
              </p>
              <p class="introduce-item leader">
                主演：<a href="javascript:;">{{ curDetail.actor || "未知" }}</a>
              </p>
              <p class="introduce-item">
                地区：<a href="javascript:;">
                  {{ curDetail.region || "未知" }}
                </a>
              </p>
              <p class="introduce-item leader">
                类型：<a href="javascript:;">
                  {{ curDetail.classify || "未知" }}
                </a>
              </p>
            </div>
            <div class="introduce">
              <p class="e-txthide2">简介：{{ curDetail.intro }}</p>
            </div>
            <a
              class="albumPlayBtn J-read-play-record"
              :href="curDetail.video==='puzzle'?`#/detail4`:`#/commonDetail?id=${curDetail.video}`"
              target="_blank"
            >
              <i class="el-icon-video-play"> </i>
              立即播放
            </a>
          </div>
        </div>
      </div></v-container
    >

    <img-show listTitle="动画片排行榜" dataKey="ranking"></img-show>
    <img-show listTitle="热播动画" dataKey="hot"></img-show>
  </div>
</template>

<script>
import imgs from "./Detail/ossImg";
import imgShow from "./Detail/imgShow.vue";

export default {
  name: "Introduce",
  components: {
    imgShow,
  },
  data() {
    return {
      curDetail: {
        title: "小熊优恩",
        img: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/images/bear.jpg.webp",
        country: "中国",
        type: "动画片",
        setNum: "26",
        duration: "14",
        totalDuration: "364",
        mediaType: "高清",
        license: "（闽）动审字[2015]第019号",
        lang: "中文",
        region: "大陆",
        actor: "骆妍倩 / 陈旭昇 / 乐嘉晔 / 吕佩玉 / 刘以嘉 / 王愫酥",
        classify: "益智",
        years: "2015",
        director: "李竹兵",
        intro:
          "一心照顾调皮孩子的“新爸爸”-阿憨；专注工作、同时也爱着孩子的“新妈妈”-莉莉；还有他们聪明顽皮，状况不断的宝贝儿子-“优恩”——他们一起为我们带来了一个关于新生家庭的奇妙故事。 没有人教过阿憨怎么养大孩子从而笑料百出的优恩。寓教于乐，这是一部超级奶爸的成长史，也是一部欢乐育儿的教科书，给大家带来快乐的感受。",
      },
    };
  },
  watch: {
    $route: {
      handler() {
        const query = this.$route.query;
        if (query.key) {
          this.curDetail = imgs[query.key][query.idx];
        }
      },
      deep: true,
    },
  },
  created() {
    const query = this.$route.query;
    if (query.key) {
      this.curDetail = imgs[query.key][query.idx];
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.intr {
  width: 100%;
  padding: 110px 100px 20px;
  .m-collection-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 20px;
    z-index: 10;
    display: flex;
    .img {
      width: 140px;
      height: 196px;
      margin-right: 30px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .content {
      width: calc(100% - 170px);
      padding: 1px 0 0;
      color: hsla(0, 0%, 100%, 0.6);
      font-size: 13px;
      line-height: 28px;
      .name {
        position: relative;
        margin: 0 0 10px;
        color: #fff;
        font-weight: 700;
        font-size: 28px;
        line-height: 32px;
      }
      .introduce-items {
        overflow: hidden;
      }
      .introduce-item {
        float: left;
        width: 300px;
        line-height: 28px;
      }
      .introduce-item.leader {
        width: calc(100% - 300px);
      }
      .introduce {
        position: relative;
        margin-top: 20px;
      }
      .albumPlayBtn {
        display: inline-block;
        vertical-align: top;
        height: 36px;
        padding: 0 20px;
        margin-right: 16px;
        margin-top: 16px;
        line-height: 36px;
        font-size: 16px;
        text-align: center;
        border-radius: 3px;
        background-color: #16e07a;
        background-image: linear-gradient(90deg, #16e05a, #16e09d);
        background-repeat: repeat-x;
        color: #fff;
        .el-icon-video-play {
          margin-right: 5px;
          vertical-align: top;
          margin-top: 10px;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .icon-wrap {
    padding: 20px;
    background: #178757;
  }

  .e-txthide2 {
    -webkit-line-clamp: 2;
  }
}
</style>
